module.exports = __webpack_public_path__ + "img/personal-training.f5e5a42d.jpg";